import React from 'react'
import { connect } from 'react-redux'
import SkillTemplate from '../organims/SkillTemplate'

const Projects=(props)=>{
  const skillsn=[1,2,3]
  const getData=()=>{
    let header=document.querySelector('.sub-menu')
    let data=header.getBoundingClientRect()
    let height=data.height
    let a=document.documentElement.style.getPropertyValue('--header-height')
    document.documentElement.style.setProperty('--projectMenu-height',`${height+a}px`)
  }

  return (
    <>
      <div onLoad={getData.bind(this)} className="sub-menu">
        <ul className="sub-menu-list">
          {
            props.data
            ?props.data.skills.map(s=>(
              <a id={s.id} key={s.id} href={`#${s.name}`}><li className="sub-menu-item">{s.name}</li></a>
            ))
            :<></>
          }
        </ul>
      </div>
      <div className="skills-projects-container">
      {
        props.data
        ?props.data.skills.map(s=>(
          <SkillTemplate key={s.name} data={s.projects} title={s.name}/>
        ))
        :skillsn.map(s=>(
          <div key={s} className="skill-template">
            <h1>Skill</h1>
            <div className="skill-projects">
              <div className="card-project ske pageprojects"></div>
              <div className="card-project ske pageprojects"></div>
              <div className="card-project ske pageprojects"></div>
              <div className="card-project ske pageprojects"></div>
            </div>
          </div>
        ))
      }
      </div>
    </>
  )
}
const mapStateToProps=(state)=>(
  {data:state.data}
)

export default connect(mapStateToProps,{})(Projects)
